module.exports = __webpack_public_path__ + "static/img/code.6f38888.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/code.png
// module id = yc7o
// module chunks = 1 3